import React from 'react';
import AppliedPaymentsExportSearchParams from './AppliedPaymentsExportSearchParams';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import AppliedPaymentsExportItem from '../../../Domain/AppliedPaymentsExportItem';
import ErrorMessage from '../../../Elements/ErrorMessage';

export default class AppliedPaymentsReportAdmin extends React.Component {
  constructor(props) {
    super(props);

    const searchItem = new AppliedPaymentsExportSearchParams();
    searchItem.IsTpRelated = this.props.isTpRelated || false;
    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      searchItem,
    };

    this.startSearch = this.startSearch.bind(this);
    this.exportAppliedPayment = this.exportAppliedPayment.bind(this);
  }

  exportAppliedPayment() {
    ClientInvoiceService.ExportPaymentAppliedInvoices(this.state.searchItem);
    ErrorMessage.SetNotification(
      'Processing started in the background. You will get a notification when the export is complete.'
    );
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={AppliedPaymentsExportItem}
          shownPanel={this.state.shownPanel}
          searchParamsType={AppliedPaymentsExportSearchParams}
          serviceFunction={ClientInvoiceService.ListAppliedForExport}
          convertDBItemsFunction={ClientInvoiceService.ConvertAppliedExportDBItems}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='CiId'
          orderDirection='Desc'
          errorCode='APRA68'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client id, payment id, client name or type...'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.exportAppliedPayment}
        />
      </div>
    );
  }
}
